import React from 'react';
import './client-logo.scss';

function ClientLogo(props) {
  return (
    <>
      <div
        className={`our-clients ${props.className || ''} ${props.theme || ''}`}
        style={{ border: "2px solid #e3e3e3" }} 
        >
        <div className="our-clients-img">
          <img className="img-fluid b-1" src={props.data} alt="" />
        </div>
      </div>
    </>
  );
}

export default ClientLogo;
